/**
 * Created by Magdalena on 20.04.2021.
 */

import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Grid from "@mui/material/Grid";
import {useTranslation} from "react-i18next";
import Modal from "@mui/material/Modal";
import {
    CEIcon,
    DataMatrixBarcodeIcon,
    InstIcon,
    LotIcon,
    SoftwareVersionIcon,
    ManufactureIcon,
    RefMDIcon,
    EuImporterIcon,
    AuthorisedRepresentativeIcon, RefIcon,
} from '../../components/icons/icons';
import { canEnterAdminPage, hasPermission, isAdmin, Permissions } from '../../store/reducers/user';
import config from "../../app/config";
import ImageDisplay from './imageDisplay';
import SmartView from './smartView';
import useOpenState from '../../hooks/useOpenState';
import {useHistory} from 'react-router-dom';
import PreferencesScreen from './preferencesScreen';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles((theme) => ({
    menu: {
        width: "min-content",
        height: "inherit",
        background: "#3D3E40"
    },
    prefView: {
        width: 400,
        height: "100%",
        backgroundColor: "white",
        color: "black !important",
        padding: 15
    },
    prefSwitch: {
        backgroundColor: "#aaa"
    },
    iconPref: {
        textAlign: 'end',
        paddingTop: 4
    },
    userName: {
        padding: "20px 10px 5px 10px",
        textAlign: "center"
    },
    userEmail: {
        padding: "0px 10px 20px 10px",
        fontSize: 10,
        textAlign: 'center'
    },
    listButton: {
        cursor: "pointer",
    },
    dropDown: {
        color: "black !important",
        border: "1px solid grey",
        borderRadius: 5,
        width: 200,
        paddingLeft: 16,
        "& MuiSelect-icon": {
            color: "black !important"
        }
    },
    colorBox: {
        padding: 12,
        borderBottom: "1px solid #dcd8d8",
        marginBottom: 10,
        display: "flex",
        alignItems: "center"
    },
    selectorItemFormControl: {
        width: "90%",
    },
    // selectorItemSelect: {
    //     width: "100%",
    //     fontSize: "80%",
    //     marginTop: "9px !important",
    // },
    selectorItemLabel: {
        fontSize: "80%",
    },
    dropDownIcon: {
        color: "black !important"
    },
    modalBody: {
        background: "white",
        color: "black",
        width: "60%",
        left: "20%",
        position: "absolute",
        top: "30px",
        padding: "20px",
        height: "90%",
        overflow: "auto",
        fontSize: "13px",
        borderRadius: "6px"
    },
    modalIcon: {
        fontSize: 38
    },
    modalMatrixIcon: {
        fontSize: 56
    },
    modalWideIcon: {
        fontSize: 38,
        width: "1.8em",
        height: "1em"
    },
    euImporterIcon: {
        fontSize: 38,
        width: "2em",
        height: "2em"
    },
    textGridItem: {
        display: "flex",
        alignItems: "center",
        marginBottom: 10
    },
    iconGridItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 10
    },
    icon: {
        cursor: "pointer"
    },
    selectorItemSelect: {
        width: "100%",
        marginTop: "9px !important",
        color: "black !important",
        maxHeight: 200,
        overflow: 'auto'
    },
}));

function UserMenu(props) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const authObject = window.keycloak ? window.keycloak : window.auth;
    const [prefView, setPrefView] = React.useState(false);
    const [aboutView, setAboutView] = React.useState(false);
    const [displayPrefView, setDisplayPrefView] = React.useState(false);
    const [isSmartViewModalOpen, openSmartViewModal, closeSmartViewModal] = useOpenState(false, true);

    const openPref = () => {
        setPrefView(!prefView);
    };
    const openAbout = () => {
        if(prefView) setPrefView(false);
        setDisplayAboutViewForSandbox(false);
        setAboutView(!aboutView);
    }

    const goToAdmin = () => {
        history.push('/admin');
    }

    const goToResearch = () => {
        history.push('/research');
    }

 //   let iconPref = openTabName === "pref" ? <ChevronLeftIcon/>: <ChevronRightIcon /> ;

    const getTabIcon = (name) => {
        return openTabName === name ? <ChevronLeftIcon/>: <ChevronRightIcon /> ;
    }

    const logOut = () => {
        authObject.logout();
    };
    const [user, setUser] = React.useState(null);

    useEffect(() => {
        if(!user && props.open) {
            authObject.loadUserInfo().then(value => {
                setUser(value);
            });
        }
    },[props.open]);

    const [openTabName, setOpenTabName] = React.useState(null);

    const handleOpenTab = (name) => {
        if(openTabName === name)  setOpenTabName(null)
        else setOpenTabName(name)
    }

    const renderSingaporeAboutView = () => {
        return (<div className={classes.modalBody}>
                <div className={classes.modalContentView}>
                    <Grid container>
                        <Grid item xs={2} className={classes.iconGridItem}>
                            <CEIcon className={classes.modalIcon}/>
                        </Grid>
                        <Grid item xs={10} className={classes.textGridItem}>
                            CE Mark (developed in compliance with Directive 93/42/EEC for Class I devices). Made in the
                            United Kingdom
                        </Grid>
                        <Grid item xs={2} className={classes.iconGridItem}>
                            <RefIcon className={classes.modalIcon}/>
                        </Grid>
                        <Grid item xs={10} className={classes.textGridItem}>
                            Eyonix R1
                        </Grid>
                        <Grid item xs={2} className={classes.iconGridItem}>
                            <LotIcon className={classes.modalIcon}/>
                        </Grid>
                        <Grid item xs={10} className={classes.textGridItem}>
                            {t(`Version ${config.version || 2.0}`)}
                        </Grid>
                        <Grid item xs={2} className={classes.iconGridItem}>
                            <InstIcon className={classes.modalIcon}/>
                        </Grid>
                        <Grid item xs={10} className={classes.textGridItem}>
                            Please read this instruction manual thoroughly before using the device
                        </Grid>
                        <Grid item xs={2} className={classes.iconGridItem}>
                            <ManufactureIcon className={classes.modalIcon}/>
                        </Grid>
                        <Grid item xs={10} className={classes.textGridItem}>
                            SoftJump Ltd
                            <br/>
                            25 Moorgate, London, England, EC2R 6AY
                        </Grid>
                    </Grid>
                    <br/>
                    <div>
                        This device fulfils the provisions of the European Commission (EC) Directive 93/42/EEC (Medical
                        Devices Directive)
                    </div>
                    <br/>
                    <div>
                        This device has been developed under the strict quality system of SoftJump Ltd.
                    </div>
                    <br/>
                    <div>
                        This software product has been designed according to:
                        <br/>
                        <br/>
                        <b>ISO 13485:2016 </b>
                        <br/>
                        Medical devices – Quality Management Systems – Requirements for regulatory purposes
                        <br/>
                        <br/>

                        <b> DCB0129:2018 </b>
                        <br/>
                        Application of clinical safety risk management to the manufacture of health IT systems
                        <br/>
                        <br/>

                        <b> DCB0160:2018 </b>
                        <br/>
                        Clinical Risk Management: its Application in the Deployment and Use of Health IT Systems
                        <br/>
                        <br/>

                        <b> IEC 62304:2006
                            <br/>
                            Amd 1:2015</b>
                        <br/>
                        Medical device software – Software lifecycle processes
                        <br/>
                        <br/>

                        <b>ISO 15233-1:2012 </b> <br/>
                        Medical Devices: Symbols to be used with medical device labels, labelling and information to be
                        supplied - Part 1: General requirements
                        <br/>
                        <br/>

                        <b>ISO 14971:2012</b>
                        <br/>
                        Medical Devices - Application of risk management to medical devices
                    </div>
                    <br/>
                    <div style={{textDecoration: 'underline'}}> DICOM conformance statement available on request</div>
                    <br/>
                    <div style={{}}><b>Revision:</b> {t(process.env.GIT)}</div>

                </div>
            </div>);
    }

    const [displayAboutViewForSandbox, setDisplayAboutViewForSandbox] = React.useState(false);

    const renderSandboxAboutView = () => {
        return (<div className={classes.modalBody}>
            <div className={classes.modalContentView}>
                <Grid container>
                    <Grid item xs={12}>
                        <h3 style={{marginTop: 20}}>
                            Product: Eyonix Sandbox
                            <br/>
                            Environment: Development / Evaluation
                            <br/>
                            Version: Sandbox build {t(`Version ${config.version || 2.0}`)}
                            <br/>
                            Status: Not for clinical use
                            <br/>
                            Regulatory status: Not a released medical device configuration
                            <br/>
                            Manufacturer: SoftJump Ltd
                            <br/> <br/>
                            Eyonix Sandbox Environment
                            <br/> <br/>
                            This environment is provided for demonstration, development, integration testing and
                            evaluation purposes only.
                            <br/>
                            This sandbox version of Eyonix may contain experimental functionality, prototype modules,
                            unvalidated workflows, test integrations and features that are not included within the
                            released Eyonix R1 Class I medical device configuration.
                            <br/>
                            The sandbox environment must not be used for the diagnosis, monitoring, treatment or
                            management of patients, or for any other clinical decision-making purpose. Any data entered
                            into this environment should be treated as test data unless explicitly agreed otherwise.
                            <br/>
                            Only the formally released and controlled version of Eyonix R1, when deployed in accordance
                            with its approved intended use, instructions for use and applicable release documentation,
                            is covered by the relevant medical device regulatory documentation. The label for this
                            version is attached
                            <span onClick={() => setDisplayAboutViewForSandbox(true)}
                                  style={{color: 'blue', cursor: 'pointer'}}> [ here ]</span>.
                            The Class IIa version is currently in progress. The labelling and information for this
                            device will be made available here when applicable.
                            <br/>
                            Use of this sandbox environment is at the user’s own risk and is subject to separate
                            validation, clinical safety assessment, information governance review and deployment
                            approval before any production or clinical use.
                        </h3>
                    </Grid>
                </Grid>
                <br/>
            </div>
        </div>);
    }

    const renderDefaultAboutView = () => {
        return (<div className={classes.modalBody}>
            <div className={classes.modalContentView}>
                <Grid container>
                    <Grid item xs={11}/>
                    {displayAboutViewForSandbox && <Grid item xs={1} className={classes.iconGridItem}>
                        <CloseIcon className={classes.icon} onClick={()=>{setDisplayAboutViewForSandbox(false)}}/>
                    </Grid>}
                    <Grid item xs={2} className={classes.iconGridItem}>
                        <CEIcon className={classes.modalIcon}/>
                    </Grid>
                    <Grid item xs={3} className={classes.textGridItem}>
                        <b>CE Mark</b>
                    </Grid>
                    <Grid item xs={7} className={classes.textGridItem}>
                        CE Marked in accordance with Regulation (EU) 2017/745. Manufactured in the United
                        Kingdom
                    </Grid>
                    <Grid item xs={2} className={classes.iconGridItem}>
                        <RefMDIcon className={classes.modalWideIcon}/>
                    </Grid>
                    <Grid item xs={3} className={classes.textGridItem}>
                        <b>Device reference</b>
                    </Grid>
                    <Grid item xs={7} className={classes.textGridItem}>
                        Eyonix R2
                    </Grid>
                    <Grid item xs={2} className={classes.iconGridItem}>
                        <SoftwareVersionIcon className={classes.modalWideIcon}/>
                    </Grid>
                    <Grid item xs={3} className={classes.textGridItem}>
                        <div>
                            <b>Version</b>
                            <br/>
                            <b>UDI</b>
                        </div>
                    </Grid>
                    <Grid item xs={7} className={classes.textGridItem}>
                        <div>
                            {t(`Version ${config.version || 2.0}`)}
                            <br/>
                            <b>(01)5070004468903(8012)2.5</b>
                            <br/>
                            <Grid item xs={3} className={classes.iconGridItem}>
                                <DataMatrixBarcodeIcon className={classes.modalMatrixIcon}/>
                            </Grid>
                        </div>
                    </Grid>
                    <Grid item xs={2} className={classes.iconGridItem}>
                        <InstIcon className={classes.modalIcon}/>
                    </Grid>
                    <Grid item xs={3} className={classes.textGridItem}>
                        <b>Instructions before use</b>
                    </Grid>
                    <Grid item xs={7} className={classes.textGridItem}>
                        Please read this instruction manual thoroughly before using the device
                    </Grid>
                    <Grid item xs={2} className={classes.iconGridItem}>
                        <ManufactureIcon className={classes.modalIcon}/>
                    </Grid>
                    <Grid item xs={3} className={classes.textGridItem}>
                        <b>Manufacturer</b>
                    </Grid>
                    <Grid item xs={7} className={classes.textGridItem}>
                        SoftJump Ltd
                        <br/>
                        5 Luke Street, Greater London, London, England, EC2A 4PX
                    </Grid>
                    <Grid item xs={2} className={classes.iconGridItem}>
                        <AuthorisedRepresentativeIcon className={classes.modalWideIcon}/>
                    </Grid>
                    <Grid item xs={3} className={classes.textGridItem}>
                        <b>Authorised <br/> Representative</b>
                    </Grid>
                    <Grid item xs={7} className={classes.textGridItem}>
                        MedEnvoy Global B.V.
                        <br/>
                        Prinses Margrietplantsoen 33
                        <br/>
                        Suite 123
                        <br/>
                        2595 AM The Hague
                        <br/>
                        The Netherlands
                    </Grid>
                    <Grid item xs={2} className={classes.iconGridItem}>
                        <EuImporterIcon className={classes.euImporterIcon}/>
                    </Grid>
                    <Grid item xs={3} className={classes.textGridItem}>
                        <b>EU Importer</b>
                    </Grid>
                    <Grid item xs={7} className={classes.textGridItem}>
                        LT2 SP Z.O.O <br/>Galczyńskiego 3 / 9, 43-600 Jaworzno, Polska
                    </Grid>
                </Grid>

                <br/>
                <div>
                    This device has been developed under the strict quality system of SoftJump Ltd.
                </div>
                <br/>
                <div>
                    This software product has been designed according to:
                    <br/>
                    <br/>
                    <b>ISO 13485:2016 </b>
                    <br/>
                    Medical devices – Quality Management Systems – Requirements for regulatory purposes
                    <br/>
                    <br/>

                    <b> DCB0129:2018 </b>
                    <br/>
                    Application of clinical safety risk management to the manufacture of health IT systems
                    <br/>
                    <br/>

                    <b> DCB0160:2018 </b>
                    <br/>
                    Application of clinical safety risk management to the manufacture of health IT systems
                    <br/>
                    <br/>

                    <b> IEC 62304:2006
                        <br/>
                        Amd 1:2015</b>
                    <br/>
                    Medical device software – Software lifecycle processes
                    <br/>
                    <br/>

                    <b>BS EN ISO 15223-<br/>1:2021+A1:2025
                    </b> <br/>
                    Medical Devices: Symbols to be used with medical device labels, labelling and information to be
                    supplied - Part 1: General requirements
                    <br/>
                    <br/>

                    <b>ISO 14971:2019</b>
                    <br/>
                    Medical Devices - Application of risk management to medical devices
                </div>
                <br/>
                <div style={{textDecoration: "underline"}}> DICOM conformance statement available on request</div>
                <br/>
                <div style={{}}><b>Revision:</b> {t(process.env.GIT)}</div>

            </div>
        </div>);
    }

    const renderAboutView = () => {
        switch (config.aboutViewVersion) {
            case 'class1':
                return renderDefaultAboutView();
            case 'singapore':
                default:
                    return renderSingaporeAboutView();
        }
    };
    return (
        <div className={classes.menu + ' user-menu-grid'}>
            <span>
                <span>
                    {user && <div>
                        <div className={classes.userName}> {user.name} </div>
                        <div className={classes.userEmail}> {user.email} </div>
                    </div>}
                </span>
            <List className={classes.root}>

                {/* FIXME: Add Theme selector! */}
                {/* <ListItem>
                    <ListItemText primary="Theme:" secondary="Dark" />
                </ListItem> */}
                <ListItem onClick={() => handleOpenTab('pref')} className={classes.listButton}>
                    <ListItemText primary="Preferences"/>
                    <ListItemAvatar classes={{root: classes.iconPref}}>
                        {getTabIcon('pref')}
                    </ListItemAvatar>
                </ListItem>
                <ListItem onClick={() => setDisplayPrefView(true)} className={classes.listButton}>
                    <ListItemText primary={t('Image Display')}/>
                </ListItem>
                  <ListItem onClick={() => handleOpenTab('smartView')} className={classes.listButton}>
                    <ListItemText primary={t('Smart View')}/>
                       <ListItemAvatar classes={{root: classes.iconPref}}>
                        {getTabIcon('smartView')}
                    </ListItemAvatar>
                </ListItem>
                {dispatch(canEnterAdminPage()) && <ListItem onClick={goToAdmin} className={classes.listButton}>
                    <ListItemText primary={t('Admin')}/>
                </ListItem>
                }
                {dispatch(hasPermission(Permissions.CAN_VIEW_PATIENT_RECORD)) && (
                        !config.modules.research.accessPermission ||
                        dispatch(hasPermission(config.modules.research.accessPermission))) &&
                    <ListItem onClick={goToResearch} className={classes.listButton}>
                        <ListItemText primary={t('Research')}/>
                    </ListItem>
                }
                <ListItem onClick={openAbout} className={classes.listButton}>
                    <ListItemText primary={t('About Eyonix')}/>
                </ListItem>
                <ListItem onClick={logOut} className={classes.listButton}>
                    <ListItemText primary={t('Sign out')}/>
                </ListItem>
            </List>
            </span>

            {openTabName === 'pref' && <PreferencesScreen/>}

            {aboutView &&
                <Modal open={aboutView}
                       onClose={openAbout}>
                    <div>
                        {config.environment === 'sandbox' && renderSandboxAboutView()}
                        {(config.environment !== 'sandbox' || displayAboutViewForSandbox) && renderAboutView()}
                    </div>
                </Modal>}

            {displayPrefView && <ImageDisplay onClose={() => {
                setDisplayPrefView(false)
            }}/>}
            {openTabName === "smartView" && <SmartView onClose={closeSmartViewModal}/>}
        </div>
    );

}

export default UserMenu;
